<template>
  <div class="m-areafilter" >
    <div class="position-pos">
      位置：
      <span class="position-tag" v-for="(tag, index) in tagList" :key="index">
        <el-tag :key="index" type="success" @click.native="getTag(index)">{{
          tag.name
        }}</el-tag>
        <span class="sub">></span>
      </span>
    </div>
    <div class="position-area" v-if="areaList && areaList.length > 0">
      区域：
      <span v-if="!mutipleArea">
        <span
          v-for="(area, index) in areaList"
          :key="index"
          :class="area.active ? 'active area' : 'area'"
          :ref="'area' + index"
          @click="optArea(index)"
          >{{ area.name }}</span
        >
      </span>
      <el-checkbox-group v-model="checkList" v-else class="mutiple-area">
        <el-checkbox
          :label="area.unitId"
          v-for="(area, index) in areaList"
          :key="index"
          >{{ area.name }}</el-checkbox
        >
      </el-checkbox-group>
    </div>
    <span
      class="floatTip"
      v-if="!mutipleArea && areaList.length > 0 && areaNone"
      @click="mutipleArea = !mutipleArea"
      >多选</span
    >
    <div class="mutipleBtn" v-if="mutipleArea" @click="cancel">
      <el-button size="small" class="el-btn-basic">取消</el-button>
      <el-button
        type="primary"
        @click="submit"
        size="small"
        class="el-btn-basic primary"
        >确认</el-button
      >
    </div>
  </div>
</template>
<script>
import accountUrl from '@/xhr/services/account'
export default {
  name: 'areaFilter',
  computed: {
    scopeIds() {
      return this.$store.state.area.currentUnitIds
    },
  },
  watch: {
    scopeIds(val, oldval) {
      // 每次切换菜单 区域信息变化 顶部高度也变化
      this.$nextTick(() => {
        this.$emit('heightChange')
      })
      // 代表只有根节点 重置区域选择 子区域也重置
      if (
        oldval[0] !== '3e2fe4faa399476786dda82bde78052c' &&
        val[0] === '3e2fe4faa399476786dda82bde78052c'
      ) {
        this.currentUnitId = val
        this.tagList = [
          {
            name: '随寓',
            unitId: ['3e2fe4faa399476786dda82bde78052c'],
          },
        ]
        this.$nextTick(() => {
          this.mutipleArea = false
        })

        if (!this.clickedRoot) {
          this.getTag(0)
        }

        // TODO : 区域多选 没有重置为单选
        // this.getAreaList(['3e2fe4faa399476786dda82bde78052c'])
      }
    },
    // 多选之后对布局产生变化
    mutipleArea() {
      this.$nextTick(() => {
        this.$emit('heightChange')
      })
    },
    // 获取当前的最新位置id数组
    tagList() {
      let len = this.tagList.length
      this.currentUnitId = this.tagList[len - 1].unitId
      console.log('最新位置的id数组', this.currentUnitId)
      this.$store.commit('SET_CURRENT_UNIT_IDS', this.currentUnitId)
      this.setLevel(this.tagList.length)
    },
  },
  data() {
    return {
      clickedRoot: false,

      userid: this.$store.state.currentUser.uid,
      tagList: [
        {
          name: '随寓',
          unitId: ['3e2fe4faa399476786dda82bde78052c'],
        },
      ],
      checkList: [],
      areaList: [],
      mutipleArea: false,
      noData: false,
      currentUnitId: [],
    }
  },
  props: {
    areaNone: Boolean, // 判断区域多选是否应存
  },
  methods: {
    toggle(id) {
      this[id] = !this[id]
    },
    // 层级标识
    setLevel(levelId) {
      localStorage.setItem('level', levelId)
    },
    getLevel() {
     return localStorage.getItem('level')
    },
    // 取消多选
    cancel() {
      this.mutipleArea = false
      this.checkList = []
    },
    submit() {
      if (this.checkList.length > 0) {
        let areaArr = this.checkList.map((item) => {
          return {
            unitId: item,
            userId: this.getUid(),
          }
        })
        let nameArr = []
        this.areaList.map((item) => {
          if (this.checkList.indexOf(item.unitId) > -1) {
            nameArr.push(item.name)
          }
        })
        this.tagList.push({
          unitId: this.checkList,
          name: nameArr.join(','),
        })
        this.getAreaList(areaArr)
      } else {
        this.mutipleArea = false
      }
      // ssftop
      // console.log('多选确认按钮看一看tag', this.tagList.length)
      // console.log('多选确认按钮看一看tag', this.tagList)
      // 本地存储设置层级
      this.setLevel(this.tagList.length)
    },

    // 入参为id数组
    getAreaList(arr) {
      // 获取列表信息 使用新的接口
      // this.$http.post(this.$store.state.accountUrl + 'unit/list/new_simple_area', {
      //   listAreaRequestBodies: arr
      // })
      accountUrl
        .getZoneListByArr({ listAreaRequestBodies: arr })
        .then((res) => {
          if (res.data.code === 200) {
            this.noData = false
            this.areaList = res.data.data
            this.areaList.map((item) => {
              item.active = false
              item.unitId = item.id
            })
            // console.log(this.areaList)
            this.$nextTick(() => {
              this.$emit('heightChange')
            })
          } else {
            // 没有数据的时候，区域清空
            this.noData = true
            this.areaList = []
            this.$nextTick(() => {
              this.$emit('heightChange')
            })
          }
        })
    },
    // 获取对应标签的区域信息，同时删除之前的下属位置信息
    getTag(index) {
      if (index === 0) {
        console.log('clicked root')
        this.toggle('clickedRoot')
        setTimeout(() => {
          this.toggle('clickedRoot')
        }, 800)
      }
      // 去掉其他位置，并在接口获取后把对应的位置区域重新赋值
      this.tagList.splice(index + 1, this.tagList.length)
      let areaArr = this.tagList[index].unitId.map((item) => {
        let tempObj = {}
        tempObj.unitId = item
        tempObj.userId = this.getUid()
        return tempObj
      })
      console.log('位置的点击事件');
      // 获取列表信息 使用新的接口
      this.getAreaList(areaArr)
      // 本地存储设置层级
      this.setLevel(this.tagList.length)
    },
    // 区域点击选择
    optArea(index) {
      this.tagList.forEach(i => {
        console.log(i);

      });
      let area = this.areaList[index]
      let areaArr = []
      // 区域单选
      if (!this.mutipleArea) {
        // 单选区域
        let areaObj = {}
        areaObj.name = area.name
        areaObj.unitId = [area.unitId]
        this.tagList.push(areaObj)

        let tempObj = {}
        tempObj.unitId = area.unitId
        tempObj.userId = this.getUid()
        areaArr.push(tempObj)
        this.getAreaList(areaArr)
      } else {
      }
      // 本地存储设置层级
      this.setLevel(this.tagList.length)
    },
  },
  created() {
    let len = this.tagList.length
    this.currentUnitId = this.tagList[len - 1].unitId
    localStorage.setItem('scopeId', this.currentUnitId)

    this.$store.commit('EMPTY_UNIT_IDS') // 将片区 ID 初始化
    let areaArr = []
    let tempObj = {}
    tempObj.unitId = this.scopeIds[0]
    tempObj.userId = this.getUid()
    areaArr.push(tempObj)
    // console.log(this.scopeIds)
    this.getAreaList(areaArr)
    // 界面大小发生变化 重新计算高度
    window.onresize = () => {
      this.$nextTick(() => {
        this.$emit('heightChange')
      })
    }
    // 本地存储设置层级
    this.setLevel(this.tagList.length)
  },
}
</script>
<style lang="scss" >
.mutiple-area span {
  font-size: 12px;
}
</style>
<style lang="scss" scoped>
.m-areafilter {
  padding-right: 64px;
  position: relative;
  font-size: 12px;

  .floatTip {
    position: absolute;
    top: 40px;
    right: 40px;
    min-width: 24px;
    color: #3cbfc4;
    font-size: 12px;
    text-align: right;
    cursor: pointer;
  }
  .position-tag:last-child .sub {
    display: none;
  }
  .position-pos,
  .position-area {
    line-height: 24px;
    color: #666;
  }
  .mutipleBtn {
    margin: 10px 0;
    text-align: center;
  }
  .position-area {
    margin-top: 13px;
    .mutiple-area {
      display: inline;
    }
    .area {
      margin-right: 10px;
      cursor: pointer;
      &:hover,
      &.active {
        color: #3cbfc4;
      }
    }
  }
  .position-pos {
    .sub {
      color: #999;
      margin: 0 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/areaFilter.vue